import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ImageSkeleton from '../../../../components/Skeletons/ImageSkeleton';

const Thumbnail = (props) => {
  const { image, onClick, index } = props;
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const imageClassName = cn('image', { '-hidden': !isImageLoaded });

  const handleImageLoaded = () => {
    setIsImageLoaded(true);
  };

  return (
    <div className="thumbnail">
      {!isImageLoaded && <ImageSkeleton />}
      <img
        src={image.thumbnailUrl}
        className={imageClassName}
        onLoad={handleImageLoaded}
        onClick={() => onClick(index)}
      />
    </div>
  );
};

export default Thumbnail;

Thumbnail.propTypes = {
  image: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};
